<template>
  <div class="player" :class="['player', 'uk-section', {'uk-section-primary': isActive, 'uk-section-muted': !isActive}]">
    <span v-if="renderWinner" class="uk-label uk-label-success">{{ $t("players.winner") }}!</span>
    <span v-else class="uk-label uk-label-success"></span>
    <div class="player-divider">
      <span class="uk-text-medium">{{ player.emoji.symbol }} {{ player.name }}</span>
      <span v-if="!singlePlayer">
        <span v-if="acquiredCards.length > 0"><br>{{ $t("players.alreadyHas", { has: acquiredCards.length }) }}
          <span v-if="needsToWin > 0">, {{ $t("players.needsToWin", {needs: needsToWin}) }}</span>
        </span>
      </span>
      <div class="score uk-padding-small">
        <span>{{ $t("players.score" )}}  {{ score }} </span>
      </div>
      <div class="won-cards">
        <bird-card v-for="card in acquiredCards" :card="card" :inTheField="false"></bird-card>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from "./Card.vue"
  import { mapGetters } from "vuex"

  export default {
    props: ["player"],
    computed: {
      isActive() {
        return this.currentPlayer.name === this.player.name;
      },
      acquiredCards() {
        let uniqueMapper = {};
        let uniqueCards = [];

        this.cardsPerPlayer[this.player.name].forEach(function(c) {
          if (!uniqueMapper[c.text]) {
            uniqueMapper[c.text] = c;
            uniqueCards.push(c);
          }
        });
        return uniqueCards;
      },
      needsToWin() {
        let difference = this.neededToWin - this.acquiredCards.length;
        return Math.max(difference, 0);
      },
      renderWinner() {
        return !this.singlePlayer && this.needsToWin < 1
      },
      score() {
        if (this.acquiredCards.length === 0) return 0
        return Math.round(((this.acquiredCards.length*2) / this.player.tries)*100)
      },
      ...mapGetters(["currentPlayer", "cardsPerPlayer", "neededToWin", "singlePlayer"])
    },
    components: {
      birdCard: Card,
    }
  }
</script>
<style scoped>
  .player {
    height: 50%;
  }
  .won-cards {
    display: flex;
    overflow: scroll;
  }

</style>



// WEBPACK FOOTER //
// src/components/Player.vue